import { render, staticRenderFns } from "./NatConLomAwardList.vue?vue&type=template&id=35431f78"
import script from "./NatConLomAwardList.vue?vue&type=script&lang=js"
export * from "./NatConLomAwardList.vue?vue&type=script&lang=js"
import style0 from "./NatConLomAwardList.vue?vue&type=style&index=0&id=35431f78&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports